import * as widgetGalleryActions from "../actions/widget-gallery.actions"

export interface State {
  open: boolean;
}

export const INITIAL_STATE: State = {
  open: false
};

export function reducer(state: State = INITIAL_STATE, action: widgetGalleryActions.Actions): State {
  switch (action.type) {
    case widgetGalleryActions.OPEN:
    {
      return {        
        open: true
      };
    }
    case widgetGalleryActions.CLOSE:
    {
      return {
        open: false
      };
    }
    default:
    {
      return state;
    }
  }
}
